{
  "pt": {
    "message": {
      "actions": {
        "delete_message": "Eliminar mensagem",
        "move_selected": "Mover mensagens selecionadas",
        "send": "Enviar"
      },
      "labels": {
        "already_replied": "já tem uma resposta",
        "cannot_delete_message": "Esta mensagem já foi lida pelo cliente, pelo que não pode ser eliminada.",
        "changes_not_saved": "Tem alterações não guardadas. Tem a certeza de que quer continuar?\np.s.: Pode abrir um novo separador para navegar para outras páginas em simultâneo.",
        "delete_message": "Isto elimina a mensagem para todos. Tenha em atenção que pode já ter sido enviada uma notificação por e-mail, dependendo das definições do destinatário.",
        "delete_message_abort": "A mensagem não pode ser eliminada",
        "move_customer_notification": "O cliente será notificado quando a mensagem for transferida para outra conversa",
        "move_to": "Mover mensagem para...",
        "moved_here": "aqui da conversa",
        "moved_message": "moveu esta mensagem",
        "moving_message": "A mover mensagem",
        "notSeenYet": "Ainda não visto",
        "seen_by": "Visto por {participants}",
        "to": "para",
        "you": "O utilizador"
      },
      "validation": {
        "message_required": "A mensagem é necessária"
      }
    }
  }
}
